import Page from "components/page/Page";
import PageTitle from "components/pageTitle/PageTitle";
import PageWrapper from "components/pageWrapper/PageWrapper";
import { memo } from "react";
import Helmet from "components/headHelmet/HeadHelmet";
import SmartLink from "components/smartLink/SmartLink";
import { useTranslation } from "react-i18next";

const PrivacyPolicyPage = () => {
  const { t } = useTranslation("privacy");

  return (
    <>
      <Helmet>
        <title>{t("metaTitle")}</title>
      </Helmet>
      <Page collapsedView={true}>
        <PageWrapper>
          <PageTitle>{t("pageTitle")}</PageTitle>
          <p>{t("intro")}</p>
          <p>
            <b>{t("infoCollection.heading")}</b>
          </p>
          <p>{t("infoCollection.searchQueries")}</p>
          <p>{t("infoCollection.thirdPartyLinks")}</p>
          <p>
            <b>{t("googleAnalytics.heading")}</b>
          </p>
          <p>{t("googleAnalytics.dataCollection")}</p>
          <p>{t("googleAnalytics.useOfData")}</p>
          <p>{t("googleAnalytics.googlePolicies")}</p>
          <p>
            <b>{t("infoSecurity.heading")}</b>
          </p>
          <p>{t("infoSecurity.body")}</p>
          <p>
            <b>{t("thirdPartyWebsites.heading")}</b>
          </p>
          <p>{t("thirdPartyWebsites.body")}</p>
          <p>
            <b>{t("childrensPrivacy.heading")}</b>
          </p>
          <p>{t("childrensPrivacy.body")}</p>
          <p>
            <b>{t("policyChanges.heading")}</b>
          </p>
          <p>{t("policyChanges.body")}</p>
          <p>
            <b>{t("contactUs.heading")}</b>
          </p>
          <p>
            {t("contactUs.body")}{" "}
            <SmartLink to={"/contact"}>{t("contactUs.contactLink")}</SmartLink>.
          </p>
          <p>{t("agreement")}</p>
        </PageWrapper>
      </Page>
    </>
  );
};

export default memo(PrivacyPolicyPage);
